import PropTypes from 'prop-types';
import React from 'react';
import ReactTooltip from 'react-tooltip';

import { extractInitials, generateUrl } from 'utils/projectHelpers';

import { colors as cssColours } from 'css/constants';

import {
  ProjectTile,
  SidebarPrimitive,
  TileContent,
  ProjectLink
} from './styles';

const ProjectSelectorBar = ({ activeProjectId, colors, projects }) => {
  const TOOL_TIP_POSITION_LEFT = 75;
  const toolTipPosition = ({ top }) => ({ left: TOOL_TIP_POSITION_LEFT, top });

  return (
    <SidebarPrimitive>
      <div>
        {projects.map((project, index) => {
          const { id, name } = project;
          return (
            <ProjectLink
              data-tip={name}
              key={name}
              data-testid="project-link"
              href={generateUrl(id, window.location.search)}
            >
              <ReactTooltip
                place="right"
                effect="solid"
                backgroundColor={cssColours.darkestGrey}
                overridePosition={toolTipPosition}
              />
              <ProjectTile
                key={id}
                selected={id.toString() === activeProjectId}
              >
                <TileContent color={colors[index]}>
                  {extractInitials(name)}
                </TileContent>
              </ProjectTile>
            </ProjectLink>
          );
        })}
      </div>
    </SidebarPrimitive>
  );
};

ProjectSelectorBar.propTypes = {
  activeProjectId: PropTypes.string,
  colors: PropTypes.array,
  projects: PropTypes.array.isRequired
};

export default ProjectSelectorBar;
